import http from '@/base/api/public'

let apiUrl = require('@/../config/sysConfig')

// 汎用マスタ
export const i_0009_conditionSearch = (page, div, type) => {
  return http.requestQuickGet(apiUrl.apiurl_masterData + '/' + page + '/' + div + '?type=' + type)
}

// 本人確認書類検索
export const i_0009_selfDocSearch = (params) => {
  return http.requestQuickGet(apiUrl.apiUrl_SelfDoc)
}

// 契約確認情報保存
export const i_0009_selfDocSave = (params) => {
  return http.requestPost(apiUrl.apiUrl_SelfDoc, params)
}

//图片查询
export const i_0009_photoFileGet = (photoPath) => {
  return http.requestQuickGetImage(apiUrl.apiUrl_FilesSearch + '?filePath=' + encodeURIComponent(photoPath) + '&resizeCd=0')
}

// 契約確認情報图片更新
export const i_0009_saveImage = (formData) => {
  return http.requestPostFormData(apiUrl.apiUrl_filesUpdate, formData)
}


// WEBPACK FOOTER //
// ./src/module/api/i_0009.js